module.exports = __webpack_public_path__ + "img/animated-sound-bars.95b7fea7.gif";